import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { setA11yContent } from "../../NavigationHelper/actions";
import { requestDelete } from "../actions";
import { checkIfGuestFlow } from "utils/checkIfGuestFLow";
import { replaceHashValues } from "utils/replaceHashValues";
import { withRouter } from "react-router";
import { checkAMLob } from "utils/checkAMLob";
import { checkNestedObject } from "utils/checkNestedObject";
import { media } from "utils/style";
import CommonHeader from "common-components/Header";
import Button from "common-components/Buttons";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Alert from "common-components/Alert";
import StyledLink from "common-components/StyledLink";
import { ENDPOINTS } from "utils/endpoints";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";

class DeleteReview extends Component {
  state = {
    loading: false
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "delete_review", "sc_pagetitle")) {
      this.props.setA11yContent("Delete review", this.props.pageContent.delete_review.sc_pagetitle);
    }
  }

  handleDeleteClick = () => {
    this.setState({ loading: true });
    if (this.props.member) {
      this.props.closeModal();
      return this.props.handleContinueClick();
    }

    if (checkIfGuestFlow(this.props.location) || this.props.member) {
      this.props.closeModal();

      return (window.location.href = window.reactGlobals.guestDeleteCTAUrl);
    }
    return this.props.requestDelete().then(() => {
      this.props.closeModal();

      if (!this.props.error) {
        this.props.history.replace("/privacy/secure/delete-request-success", {
          confirmAuth: true
        });
      }
      this.setState({ loading: false });
    });
  };

  renderContent = pageContent => {
    if (checkAMLob() === "vzw") {
      if (
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.from &&
        "delete-member" === this.props.location.state.from
      ) {
        return (
          <ButtonContainer>
            <StyledLink background={pageContent.buttons[0].type} href={ENDPOINTS.LOGOUT} linkType="anchor">
              {pageContent.buttons[0].text}
            </StyledLink>

            <Button type="button" onClick={this.props.closeModal} background={pageContent.buttons[1].type}>
              {pageContent.buttons[1].text}
            </Button>
          </ButtonContainer>
        );
      }
      return (
        <ButtonContainer>
          <Button
            background={pageContent.buttons[0].type}
            disabled={window.reactGlobals.isCsr}
            onClick={this.handleDeleteClick}
          >
            {pageContent.buttons[0].text}
          </Button>
          <Button onClick={this.props.closeModal} background={pageContent.buttons[1].type}>
            {pageContent.buttons[1].text}
          </Button>
        </ButtonContainer>
      );
    } else if (checkAMLob() === "vzt") {
      return (
        <ButtonContainer>
          <Button
            background={pageContent.buttons[0].type}
            disabled={window.reactGlobals.isCsr}
            onClick={this.handleDeleteClick}
          >
            {pageContent.buttons[0].text}
          </Button>
          <Button type="button" onClick={this.props.closeModal} background={pageContent.buttons[1].type}>
            {pageContent.buttons[1].text}
          </Button>
        </ButtonContainer>
      );
    }
    return (
      <ButtonContainer>
        <StyledLink
          background={pageContent.buttons[0].type}
          href={window.reactGlobals.guestDeleteCTAUrl}
          linkType="anchor"
        >
          {pageContent.buttons[0].text}
        </StyledLink>
        <Button onClick={this.props.closeModal} background={pageContent.buttons[1].type}>
          {pageContent.buttons[1].text}
        </Button>
      </ButtonContainer>
    );
  };

  render() {
    const isDeleteForMember =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.from &&
      "delete-member" === this.props.location.state.from;

    const { pageContent: aemResponse, memberModalContent, deleteLineSelection, error } = this.props;

    let pageContent =
      aemResponse.delete_review ||
      aemResponse.delete_review_guest ||
      memberModalContent ||
      (isDeleteForMember && this.props.location.state.pageContent);

    if (!pageContent || !pageContent.section_description) {
      return <Redirect to="/privacy/secure/delete" />;
    }

    return (
      <Container>
      <Div noTabletPadding>
        {(this.state.loading || this.props.loading) && (
          <RectangleLoader
            style={{
              position: "absolute",
              top: "0",
              right: "0",
              bottom: "0",
              left: "0",
              background: "white",
              zIndex: "999999",
              padding: "0",
              margin: "0",
              animation: "0"
            }}
          />
        )}
        {error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        <>
        <ModalTitle>
          <Header>{pageContent.section_title}</Header>
          </ModalTitle>
          <ModalBody>
            
            {convertStringToElements(
              replaceHashValues(pageContent.section_description, {
                deleteLineSelection: deleteLineSelection === "all" ? "all lines on your account" : "your line"
              })
            )}
            
            </ModalBody>
         
            {this.renderContent(pageContent)}
          {/* </Div> */}
       
        </>
      </Div>
      </Container>
    );
  }
}

const mapStateToProps = ({ loadingAndErrorState: { loading, error }, deleteLineSelection, pageContent }) => ({
  loading,
  error,
  pageContent,
  deleteLineSelection
});

export default withRouter(
  connect(
    mapStateToProps,
    { setA11yContent, requestDelete }
  )(DeleteReview)
);

DeleteReview.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  requestDelete: PropTypes.func,
  pageContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};


const Div = styled.div`
  
  ${media.mobile`
  padding-right: 0;
`}
`;

const ButtonContainer = styled.div`
  margin-top: 32px;
  display: flex;

  ${media.mobile`
  @media only screen and (max-width: 480px) {
  // display : flex;
  // flex-direction:row;
   
      // align :center; 
      // position:absolute;
      // bottom:10px;
      // right:0px;
      // left:0px;
      // margin:20px;
  }
 
`}

  
`;

const Header = styled(CommonHeader)`
font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
font-size: 32px;
font-style: normal;
font-weight: 400;
line-height: 36px;
margin-bottom:32px;
${media.mobile`
 font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
 margin-top: 25px;
 font-size: 24px;
 font-style: normal;
 font-weight: 400;
 line-height: 28px;
`}
`;

const Container = styled.div`
  max-width: 420px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const P = styled.p`
margin-top: 32px;
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-weight: 400;
 font-size: 16px;
 line-height: 20px;
`;